import React from 'react';
import { useParams } from 'react-router-dom';
import StudioV2PermitDemoPage from './StudioV2PermitDemoPage';
import StudioV2PermitPortalPage from './StudioV2PermitPortalPage';

/**
 * Vanity-host citizen entry (`/advisor`, `/advisor/:portal`).
 * Package resolved from Host; apex still works with SF fallback.
 */
export default function CitizenAdvisorHostPage() {
  const { portal } = useParams();
  const basePath = '/advisor';
  if (portal) {
    return (
      <StudioV2PermitPortalPage
        basePath={basePath}
        defaultPackageId="san-francisco"
      />
    );
  }
  return (
    <StudioV2PermitDemoPage
      basePath={basePath}
      defaultPackageId="san-francisco"
    />
  );
}
